export default __webpack_public_path__ + "static/media/right-menu.a2505263.svg";